/* eslint-disable eqeqeq */
import { LoginProps, LoginState } from "../../types/appTypes";
import { Form, Button, FloatingLabel, InputGroup, Row, Col } from "react-bootstrap";
import { Eye, EyeSlash } from "react-bootstrap-icons";
// import { KanbanizeCredentials, KanbanizeError, KanbanizeTokenObj } from "../../types/kanbanizeTypes";
// import { Navigate } from "react-router-dom";
// import { doPost, isKanbanizeError } from "../../utils/utils";
import React from "react";
import { doPost } from "../../utils/utils";

export class Login extends React.Component<LoginProps, LoginState> {
	constructor(props: LoginProps) {
		super(props);
		let loginState: LoginState = {
			domain: undefined,
			apiKey: undefined,
			accessCode: undefined,
			authToken: undefined,
			validated: false,
			apiKeyFieldTextType: "password",
			codeFieldTextType: "password",
			sessionCreated: undefined,
		};
		this.state = loginState;
		this.inputChange.bind(this);
		// this.submitForm.bind(this);
		localStorage.removeItem("kanbanizeSessionCreated");
		this.props.setCurrentComponent("Login");
	}

	inputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { name, value } = event.target;
		this.setState({ [name]: value } as Pick<LoginState, "apiKey" | "domain" | "accessCode">);
	};

	submitForm = () => {
		this.props.setGeneralError(false);
		const { domain, apiKey } = this.state;
		if (!domain || !apiKey) return;
		this.props.getUserToken(domain, apiKey);
	};

	accessCorporateLogin = async () => {
		try {
			this.props.setGeneralError(false);
			const url = `${this.props.integrationUrl}/api/login/corporate`;
			const orgList = await doPost<{ user_orgs: string[]; current_org: string }>(url, {});
			const integration = process.env.REACT_APP_INTEGRATION_SERVICE;
			if (!integration) {
				this.props.setGeneralError("Could not recover environment variable: REACT_APP_INTEGRATION_SERVICE");
				return;
			}
			let err;
			if (!orgList.user_orgs || orgList.user_orgs.length == 0) {
				err = `You do not belong to any of the allowed corporate business
            If you believe you shoul be able to access, please, check:
            - You are actually a member of the organization at ${integration}.
            - The organization has been added to the corporate login organization list by our team.
            If the issue is the latter, please, contact support.`;
			}
			if (err) {
				this.props.setGeneralError(err);
				return;
			}
			this.props.setCorporateUserOrgs(orgList.user_orgs);
			this.props.changeCorporateUserOrg(orgList.current_org, false);
		} catch (e: any) {
			this.props.setGeneralError(e);
		}
	};

	render(): React.ReactNode {
		return (
			<>
				<Form noValidate validated={this.state.validated} id="form1">
					<Form.Group className="m-3" controlId="kanbanizeDomain">
						<FloatingLabel label="Businessmap url: (e.g. https://yourcompany.kanbanize.com)">
							<Form.Control
								required
								name="domain"
								type="url"
								placeholder="https://example.kanbanize.com"
								onChange={this.inputChange}
							/>
						</FloatingLabel>
						<Form.Control.Feedback>Looks good!</Form.Control.Feedback>
						<Form.Control.Feedback type="invalid">This field is required</Form.Control.Feedback>
					</Form.Group>
					<Form.Group className="m-3" controlId="kanbanizeApiKey">
						<InputGroup>
							<FloatingLabel label="Businessmap api key:">
								<Form.Control
									required
									name="apiKey"
									type={this.state.apiKeyFieldTextType}
									placeholder="********"
									onChange={this.inputChange}
								/>
							</FloatingLabel>
							<Form.Control.Feedback>Looks good!</Form.Control.Feedback>
							<Form.Control.Feedback type="invalid">This field is required</Form.Control.Feedback>
							{(this.state.apiKeyFieldTextType === "text" && (
								<InputGroup.Text
									onClick={() => {
										this.setState({ apiKeyFieldTextType: "password" });
									}}
								>
									<EyeSlash />
								</InputGroup.Text>
							)) || (
								<InputGroup.Text
									onClick={() => {
										this.setState({ apiKeyFieldTextType: "text" });
									}}
								>
									<Eye />
								</InputGroup.Text>
							)}
						</InputGroup>
					</Form.Group>
				</Form>
				<Form noValidate validated={this.state.validated} id="form2">
					<Row>
						<Col></Col>
						<Col>
							<Button className="col-12 mb-3" size="lg" variant="primary" type="button" onClick={this.submitForm}>
								Access
							</Button>
						</Col>
						<Col></Col>
					</Row>
					{process.env.REACT_APP_INTEGRATION_SERVICE == "GitHub" && (
						<Row className="text-center">
							<p>
								Note: If you are part of a GitHub organization which has been pre-configured by Businessmap support you
								may access the application through our corporate login service{" "}
								<a
									href="https://businessmap.io"
									onClick={e => {
										e.preventDefault();
										this.accessCorporateLogin();
									}}
								>
									here
								</a>
							</p>
						</Row>
					)}
				</Form>
			</>
		);
	}
}
